<template>
  <div>
    <label class="flex items-center cursor-pointer">
      <input type="checkbox" :checked="modelValue" class="sr-only" @change="onChange" />
      <div
        class="checkbox flex items-center justify-center w-4 h-4"
        :class="modelValue ? 'bg-grey-darkest' : 'bg-white border-1 border-grey'"
      >
        <span v-if="modelValue" class="icon-checkmark text-white text-3xs"></span>
      </div>
      <p :class="labelClass">{{ label }}</p>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    labelClass: { type: String, default: '' }
  },

  emits: ['update:modelValue'],

  methods: {
    /* The nested input is the single source of interaction. The label used to
       carry its own @click handler as well, so one click could run the toggle
       two or three times - the label's own click, the click the label forwards
       to the input, and the input's change - and whether that netted out to a
       toggle or to nothing depended on when Vue flushed the prop update in
       between. Reading event.target.checked also beats negating the prop,
       because it reflects what the control actually is. */
    onChange (event) {
      this.$emit('update:modelValue', event.target.checked)
    }
  }
}
</script>

<style scoped>
.checkbox {
  transition: background-color 0.3s ease-in-out;
}
</style>
